module.exports = __webpack_public_path__ + "assets/img/2006.13a6ac96.png";